import { useEffect, useState } from 'react';
import { API_BASE } from './client';

export function accountDeletionMessagePolicy(erasesMessages: boolean): string {
  return erasesMessages
    ? 'Message text you authored is removed during deletion. Other members retain their own messages.'
    : 'Under the current policy, sent-message text remains without your identity. Authored message removal is awaiting activation.';
}

export async function readAccountMessageErasure(
  fetcher: typeof fetch = fetch,
  signal?: AbortSignal,
): Promise<boolean> {
  try {
    const response = await fetcher(`${API_BASE}/capabilities`, {
      cache: 'no-store',
      credentials: 'omit',
      signal,
    });
    if (!response.ok) return false;
    const body = await response.json();
    return body?.data?.account_message_erasure === true;
  } catch {
    return false;
  }
}

export function useAccountMessageErasure(enabled = true, revision = 0): boolean {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    setReady(false);
    void readAccountMessageErasure(fetch, controller.signal).then((value) => {
      if (!controller.signal.aborted) setReady(value);
    });
    return () => controller.abort();
  }, [enabled, revision]);
  return enabled && ready;
}
